/**
 * @author Kenny G Perez
 * @yields danger zone file
 */

import { useRootLoaderData } from '@/root.tsx'
import { useLoaderData, useParams } from '@remix-run/react'
import { type PropsWithChildren } from 'react'

type StrapiLayoutResolverProps = PropsWithChildren<{
	/**
	 * This maps the sub domain to the group slug from strapi
	 */
	config: Record<string, (...args: any) => JSX.Element>
}>

export const StrapiLayoutResolver = (props: StrapiLayoutResolverProps) => {
	const { slugForGroup } = useRootLoaderData()
	const LayoutComp = props.config[slugForGroup]

	console.log('LayoutComp', LayoutComp, slugForGroup, props.config)

	if (!LayoutComp) {
		return <div>404</div>
	}

	return <LayoutComp>{props.children}</LayoutComp>
}
